export type ClientEmailSource = 'finance' | 'client';

export const formatCcList = (emails: string[] | undefined) =>
  (emails ?? []).filter((email) => email.trim().length > 0).join('; ');

export const resolveEmailSource = (
  to: string,
  financeEmail?: string,
  clientEmail?: string
): ClientEmailSource | null => {
  const normalizedTo = to.trim().toLowerCase();
  if (!normalizedTo) {
    return null;
  }

  if (financeEmail?.trim().toLowerCase() === normalizedTo) {
    return 'finance';
  }

  if (clientEmail?.trim().toLowerCase() === normalizedTo) {
    return 'client';
  }

  return null;
};
